import { Typography } from '@ui';
import { Dropdown } from 'antd';
import styled from 'styled-components';

export const StyledText = styled(Typography.Text)`
    overflow: hidden;
    max-width: 160px;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: end;
`;

export const StyledDropdown = styled(Dropdown)`
    .ant-card-body {
        padding-block: 24px;
    }
`;
